export const SAGA_REQUEST_KEY = {
	DISABLE_TOAST: 'saga_disable_toast',
	LOADING_ID: 'saga_loading_id',
	ALL: 'saga_promise_all',
	SUPER_USER: 'saga_super_user',
};
